import { render, staticRenderFns } from "./DemeritoPage.vue?vue&type=template&id=dd485d5e"
import script from "./DemeritoPage.js?vue&type=script&lang=js&external"
export * from "./DemeritoPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports